import styles from "./DeliveryServiceItem.module.scss";
import Checkbox from "@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox";
import { useRef, useState } from "react";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  checked: boolean;
  description: string;
  disabled: boolean;
  display: string;
  serviceId: string;
  title: string;
  toggleCheck: (serviceId: string) => void;
  value: number;
};

export const DeliveryServiceItem = ({
  checked,
  description,
  disabled,
  display,
  serviceId,
  title,
  toggleCheck,
  value,
}: Props) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoButtonRef = useRef<HTMLButtonElement>(null);
  const isFree = value === 0;

  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
    infoButtonRef.current?.focus();
  };
  const handleTooltipCollapseClick = () => setShowInfo(false);
  const handleToggleCheckClick = () => toggleCheck(serviceId);

  return (
    <div
      id="product:delivery-service"
      data-testid="product:delivery-service"
      className={styles.deliveryServiceItemWrapper}
    >
      <div className={styles.serviceItem}>
        <Checkbox
          isControlled={true}
          className={styles.serviceInfo}
          id={serviceId}
          label={title}
          ariaLabel={title}
          checked={checked}
          onClick={handleToggleCheckClick}
          name={title}
          value={""}
          additionalInfo={isFree ? "FREE" : display}
          disabled={disabled}
        />
        <button
          data-testid="product:delivery-service:tooltip:button:expand"
          ref={infoButtonRef}
          onClick={handleTooltipExpandClick}
          className={styles.serviceToolTip}
          aria-label={`${title} information`}
        >
          {" "}
        </button>
      </div>
      <div
        data-testid="product:delivery-service:tooltip"
        className={cx(styles.infoBlock, { hide: !showInfo })}
      >
        <button
          aria-label="Collapse tooltip"
          data-testid="product:delivery-service:tooltip:button:collapse"
          onClick={handleTooltipCollapseClick}
          className={styles.closeButton}
        ></button>
        <div aria-live="polite" className={styles.tip}>
          <h4 className={styles.title}>{title}</h4>
          <div dangerouslySetInnerHTML={{ __html: `${description}` }} />
        </div>
      </div>
    </div>
  );
};
